import { render, staticRenderFns } from "./MonacoEditor.vue?vue&type=template&id=114c535c"
import script from "./MonacoEditor.vue?vue&type=script&lang=ts"
export * from "./MonacoEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports